<template>
  <span>
    <el-input
      style="width:55px;margin-right:5px"
      size="small"
      v-model.number="vday"
      max="16"
    />天
    <el-select style="width:65px" placeholder="" size="small" v-model="vhour">
      <el-option v-for="h in hours" :value="h" :label="h" :key="h" />
    </el-select>
    时
    <el-select style="width:65px" placeholder="" size="small" v-model="vminute">
      <el-option v-for="m in minutes" :value="m" :label="m" :key="m" />
    </el-select>
    分
  </span>
</template>
<script>
export default {
  props: {
    day: {
      type: String,
      default: '00',
    },
    hour: {
      type: String,
      default: '00',
    },
    minute: {
      type: String,
      default: '00',
    },
  },
  data() {
    return {
      vday: this.day,
      vhour: this.hour,
      vminute: this.minute,
    }
  },
  watch: {
    day(val) {
      this.vday = val.toString().replace(/[^0-9]/g, '')
      if (this.vday != '') {
        this.vday = parseInt(this.vday)
      }
    },
    hour(val) {
      this.vhour = val
    },
    minute(val) {
      this.vminute = val
    },
    vday(val) {
      this.$emit('update:day', val.toString())
    },
    vhour(val) {
      this.$emit('update:hour', val)
    },
    vminute(val) {
      this.$emit('update:minute', val)
    },
  },
  computed: {
    hours() {
      return Array.from({ length: 24 }).map((t, i) =>
        i.toString().padStart(2, '0')
      )
    },
    minutes() {
      return Array.from({ length: 60 }).map((t, i) =>
        i.toString().padStart(2, '0')
      )
    },
  },
}
</script>
